import { action, observable } from 'mobx'
import { InfoOptionRequest } from '../requests/InfoOptionRequest'

class InfoOptionStore {
  @observable infoOptionData = null
  @observable infoOptionList = {} // object sau khi reduce

  @action getInfoOption = async params => {
    const response = await InfoOptionRequest.getInfoOption(params)
    this.infoOptionData = response.data

    this.infoOptionList = Array.isArray(response.data)
      ? response.data.reduce((acc, item) => {
          acc[item.id] = item.value
          return acc
        }, {})
      : {}

    return this.infoOptionData
  }

  @action clear = () => {
    this.infoOptionData = null
    this.infoOptionList = {}
  }
}

export default new InfoOptionStore()
